import React from 'react';
import PropTypes from 'prop-types';
import { get, map } from 'lodash';
import moment from 'moment';
import { SanitizeHtml, Image, Slugify } from '@bd/bdcore-utilities';
import { css } from '@bd/bdui-styles/emotion';
import { Link } from '@bd/bdcore-named-routes';
import AccordionToggle from '../../components/AccordionToggle';
// import { colors } from '../../styles';

moment.locale('en', {
  relativeTime: {
    future: 'in %s',
    past: '%s ago',
    s: 'seconds',
    m: '1 minute',
    mm: '%d minutes',
    h: '1 hour',
    hh: '%d hours',
    d: '1 day',
    dd: '%d days',
    M: '1 month',
    MM: '%d months',
    y: '1 year',
    yy: '%d years',
  },
});

const styles = css`
  padding: 45px 0 30px 0;
  position: relative;
  @media (min-width: 992px) {
    padding: 120px 0 60px 0;
    background-position: 70vw -10vh;
    background-size: 60vh auto;
    background-repeat: no-repeat;
  }
  .Conference_bannerHeading {
    font-size: 48px;
    font-weight: 700;
    margin: 0 0 90px 0;
    @media (min-width: 992px) {
      font-size: 60px;
    }
  }
  .Conference_dayList {
    list-style: none;
    margin: 0 0 75px 0;
    padding: 0;
  }
  .Conference_dayHeading {
    font-size: 32px;
    text-align: center;
    text-transform: uppercase;
    margin: 0 0 15px 0;
    padding: 0 30px;
    @media (min-width: 992px) {
      font-size: 60px;
      margin: 0 0 30px 0;
    }
  }
  .Conference_sessionWrapper {
    padding-top: 60px;
    padding-bottom: 60px;
  }
  .Conference_sessionHeading {
    font-size: 28px;
    text-align: center;
    font-weight: 700;
    margin: 0 0 15px 0;
    padding: 0 0 15px 0;
    border-bottom: 1px solid #EEEEEE;
    @media (min-width: 992px) {
      margin: 0 0 30px 0;
      padding: 0 0 30px 0;
    }
    span {
      display: block;
      font-weight: 400;
      font-size: 14px;
      margin: 3px 0 0 0;
      @media (min-width: 992px) {
        font-size: 21px;
      }
    }
  }
  .Conference_sessionCard {
    width: 100%;
    border: 1px solid #EEEEEE;
    background-image: url('/images/hbt-card-bg.svg');
    background-position: center center;
    background-size: cover;
    position: relative;
    padding-top: 56.25%;
    margin: 0 0 15px 0;
    &::before {
      content: '';
      position: absolute;
      left: 0;
      right: 0;
      top: 0;
      bottom: 0;
      background-color: rgba(69, 161, 200, .97);
      z-index: 1;
    }
    &-video {
      &::before {
        background-color: rgba(198, 204, 39, .95);
      }
    }
  }
  .Conference_sessionCardContent {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    position: absolute;
    z-index: 2;
    text-align: center;
    .btn {
      padding: 10px 15px;
      background-color: #FFFFFF;
      @media(min-width: 992px) {
        padding: 15px 25px;
      }
    }
    .btn.future {
      background-color: rgba(255, 255, 255, 0.6);
    }
  }
  .Conference_timeList {
    list-style: none;
    margin: 0 0 45px 0;
    padding: 0;
  }
  .Conference_timeItemTitle {
    font-size: 20px;
    line-height: 1;
    margin: 0 0 10px 0;
    padding: 0 0 0 28px;
    background-image: url('/images/icon-clock.svg');
    background-repeat: no-repeat;
    background-size: 20px 20px;
    small {
      font-size: 14px;
    }
  }
  .Conference_eventList {
    list-style: none;
    margin: 0 0 15px 0;
    padding: 0;
  }
  .Conference_eventItem {
    padding: 15px 15px;
    border: 1px solid #cccccc;
    margin: 0;
    background-color: #F5F5F5;
    position: relative;

    &-active {
      border: 5px solid #DB2150;
    }
  }
  .Conference_eventItemTitle {
    font-weight: 700;
    font-size: 21px;
    line-height: 1.2;
    margin: 0;
    color: #FFFFFF;
    width: 90%;
    @media (min-width: 992px) {
      width: 80%;
      font-size: 32px;
    }
  }
  .Conference_eventItemDescription {
    margin: 10px 0 0 0;
    font-weight: 700;
    font-size: 16px;
    display: block;
    @media (min-width: 992px) {
      font-size: 24px;
      margin: 15px 0 0 0;
    }
  }
  .Conference_speakersTextList {
    list-style: none;
    margin: 8px 0 0 0;
    padding: 0;
  }
  .Conference_speakersTextListItem {
    display: inline-block;
    border-right: 1px solid #CCCCCC;
    padding: 0 10px 0 0;
    margin: 0 10px 0 0;
    line-height: 1;
    &:last-child {
      border: 0;
    }
  }
  .Conference_speakersTextListItemHeading {
    padding: 3px 10px;
    background-color: #2B2B2B;
    color: #FFFFFF;
    display: inline-block;
    line-height: 1;
    margin: 0 10px 0 0;
    font-weight: 700;
  }
  .Conference_speakerPhotoList {
    position: relative;
    padding: 0;
    margin: 10px 0 10px 0;
  }
  .Conference_speakerPhotoListItem {
    display: inline-block;
    margin: 10px 10px 0 0;
    img {
      border-radius: 100%;
    }
  }

  .Conference_eventScrollTarget {
    position: absolute;
    top: -50px;
  }
  .Conference_eventMore {
    height: 40px;
  }
  .Conference_eventMoreIcon {
    margin: 0 0 0 -5px;
    width: 38px;
  }
`;

function getDateTime(date, time) {
  const timeAvailable = new Date(get(time, 'time_available'));
  const dateTime = new Date();

  dateTime.setFullYear(date.getFullYear());
  dateTime.setDate(date.getDate());
  dateTime.setMonth(5);
  dateTime.setSeconds(timeAvailable.getSeconds());
  dateTime.setMinutes(timeAvailable.getMinutes());
  dateTime.setHours(timeAvailable.getHours() - 1);

  return dateTime;
}

class ConferenceTable extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      availableTimes: [],
    };

    this.count = 0;
  }

  componentDidMount() {
    this.interval = setInterval(this.setAvailableTimes, 3000);
    this.setAvailableTimes();
  }

  componentWillUnmount() {
    clearInterval(this.interval);
  }

  setAvailableTimes = () => {
    const { page: { schedule: [schedule] } } = this.props;

    // this.count += 1;

    const times = [];
    const now = moment();

    (schedule.days || []).forEach(day => {
      const date = new Date(day.date);
      (day.times || []).forEach(time => {
        const dateTime = getDateTime(date, time);

        if (now.isSameOrAfter(moment(dateTime).subtract(10, 'minutes')) || this.count > 5) {
          times.push(time._id);
        }
      });
    });

    this.setState({
      availableTimes: times,
    });
  }

  render() {
    const { page, widget } = this.props;
    const { availableTimes } = this.state;

    return (
      <div className={styles} id="agenda">
        <div>
          <div>
            <div>
              {get(page, 'schedule[0].days', []).map(day => (
                <ul key={day._id} className="Conference_dayList">
                  <li className="Conference_dayItem">
                    <AccordionToggle
                      button={() => (<h2 className="Conference_dayHeading">{get(day, 'day_title')}</h2>)}
                      isOpen
                    >
                      {day.times.map(time => {
                        const available = availableTimes.includes(time._id);
                        const dateTime = moment(getDateTime(new Date(day.date), time));
                        const duration = moment
                          .duration(dateTime.subtract(10, 'minutes').diff(moment()))
                          .humanize(true, {
                            s: 45,
                            m: 45,
                          });

                        return (
                          <ul key={time._id} className="list-unstyled container">
                            <li className="row Conference_sessionWrapper">
                              <div className="col-12">
                                <h3 className="Conference_sessionHeading">{get(time, 'time_block_title')} <span>{moment(day.date).format('MMM D, YYYY')} | {get(time, 'time')} Eastern Time</span></h3>
                              </div>
                              {time.event.map(event => {
                                const speakers = widget.speakers
                                  .filter(speaker => map(event.speakers, 'speaker').includes(speaker._id));
                                return (
                                  <ul className={`${time.event.length > 1 ? 'col-lg-6 mb-3 mb-lg-0' : 'col-12'} list-unstyled`} key={event.title}>
                                    <li>
                                      <span />
                                      <div>
                                        <div className={`Conference_sessionCard ${event.video[0].type === 'Youtube' && 'Conference_sessionCard-video'}`}>
                                          <div className="Conference_sessionCardContent">
                                            {
                                              (get(event, 'video[0].type') === 'Zoom' || (get(event, 'video[0].type') === 'Youtube' && !available)) &&
                                              <h4 className="Conference_eventItemTitle">{get(event, 'title')}</h4>
                                            }
                                            {
                                              get(event, 'video[0].type') === 'Zoom' &&
                                              available &&
                                              <div>
                                                <span className="Conference_eventItemDescription">
                                                  Zoom Meeting ID: {get(event, 'video[0].zoom_id', []).replace(/^(\d{3})(\d{3})(\d{1,})$/, '$1-$2-$3')}
                                                </span>
                                                <a href={get(event, 'video[0].link')} target="_blank" rel="noopener noreferrer" className="btn mt-3">Join the Zoom Meeting</a>
                                              </div>
                                            }
                                            {
                                              get(event, 'video[0].type') === 'Youtube' &&
                                              available &&
                                              <div className="embed-responsive embed-responsive-16by9" dangerouslySetInnerHTML={SanitizeHtml(get(event, 'video[0].video'))} />
                                            }
                                            {
                                              get(event, 'video[0].type') === 'Zoom' &&
                                              !available &&
                                              <div>
                                                <span className="Conference_eventItemDescription">Zoom Meeting</span>
                                                <a target="_blank" rel="noopener noreferrer" className="btn mt-3 future">Available {duration}</a>
                                              </div>
                                            }
                                            {
                                              get(event, 'video[0].type') === 'Youtube' &&
                                              !available &&
                                              <div>
                                                <span className="Conference_eventItemDescription">On Demand Video</span>
                                                <a target="_blank" rel="noopener noreferrer" className="btn mt-3 future">Available {duration}</a>
                                              </div>
                                            }
                                          </div>
                                        </div>
                                        {
                                          speakers.length > 0 &&
                                          <ul className="Conference_speakersTextList">
                                            {
                                              event.company &&
                                              <li className={`Conference_speakersTextListItemHeading ${Slugify(event.company)}`}>{event.company}</li>
                                            }
                                            {speakers.map(speaker => (
                                              <li key={speaker._id} className="Conference_speakersTextListItem">
                                                <Link name="speakers" hash={`#${Slugify(speaker.name)}`}>{speaker.name}</Link>
                                              </li>
                                              ),
                                            )}
                                          </ul>
                                        }
                                        {
                                          speakers.length > 0 &&
                                          <ul className="Conference_speakerPhotoList">
                                            {speakers.filter(s => get(s, 'headshot.contentUrl')).map(speaker => (
                                              <li key={speaker._id} className="Conference_speakerPhotoListItem">
                                                <Link name="speakers" hash={`#${Slugify(speaker.name)}`}>
                                                  <Image
                                                    src={get(speaker, 'headshot.contentUrl')}
                                                    alt={speaker.name}
                                                    width={60}
                                                    height={60}
                                                    exact
                                                  />
                                                </Link>
                                              </li>
                                              ),
                                            )}
                                          </ul>
                                        }
                                      </div>
                                      {
                                        event.description &&
                                        <AccordionToggle
                                          scollToTop={false}
                                          button={() => (
                                            <div className="Conference_eventMore">
                                              {
                                                event.description &&
                                                <div>
                                                  <img className="Conference_eventMoreIcon" src="/images/icon-more.svg" alt="" /> <small>View Description</small>
                                                </div>
                                              }
                                            </div>
                                          )}
                                        >
                                          <div className="Conference_eventDescription" dangerouslySetInnerHTML={SanitizeHtml(get(event, 'description'))} />
                                        </AccordionToggle>
                                      }
                                    </li>
                                  </ul>
                                );
                              },
                            )}
                            </li>
                          </ul>
                        );
                      },
                      )}
                    </AccordionToggle>
                  </li>
                </ul>
                ),
              )}

            </div>
          </div>
        </div>
      </div>
    );
  }
}

ConferenceTable.propTypes = {
  page: PropTypes.object.isRequired,
  widget: PropTypes.object.isRequired,
};

export default ConferenceTable;



// WEBPACK FOOTER //
// ./src/pages/Conference/ConferenceTable.js